import { connect } from 'react-redux';

import SearchResults from './search-results';
import { onSearch, onLoadCourse, onLoadCard } from '../../reducers/course.reducers';
import { selectTest } from '../../reducers/test.reducers';

const mapStateToProps = state => ({
  results: state.courses.searchResults,
  searchTerm: state.courses.searchTerm,
  loading: state.courses.isLoadingSearchResults,
  courses: state.courses.courses,
  card: state.courses.cardForModal
});

const mapDispatchToProps = dispatch => ({
  search: searchTerm => dispatch(onSearch(searchTerm)),
  loadCourse: course => dispatch(onLoadCourse(course)),
  loadCard: card => dispatch(onLoadCard(card)),
  loadTest: (test) => dispatch(selectTest(test))
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);



// WEBPACK FOOTER //
// ./src/app/main/search/search-results.container.js